import React, { useContext, useState } from 'react'
import style from "./UpdatePassword.module.css"
import {useParams,useNavigate} from "react-router-dom"
import { LoginStatus } from '../../App'
import Loader from '../Utilities/Loader'
import Footer from '../Partialpages/Footer'
import {forgotUpdate} from "../../Validations/Authentication"
import CustomerNav from '../Partialpages/CustomerNav'
import { toast } from 'react-toastify';
import { db } from "../../firebase/config";
import {
    collection,
    where,
    query,
    getDocs,
    updateDoc,
    doc,
} from "firebase/firestore";
import { Base64 } from "../../EncodeDecode/index";

function UpdatePassword() {

    const forgot_password_colRef = collection(db, "forgot_passwords");

    const [passwordType,setPasswordType] = useState({
        newPass:"password",
        confPass:"password"
    })
    const [currentErrors, setCurrentErrors] = useState([])
    const [isLoading,setIsLoading] = useState(false)
    const [confirmPassword,setConfirmPassword] = useState("")
    const [newPassword,setNewPassword] = useState("")
    const navigate = useNavigate()
    const isLogin = useContext(LoginStatus)
    
    const {id} = useParams()

    const confirmPasswordHandler = (e) =>{
        setConfirmPassword(e.target.value)
    }
    const newPasswordHandler = (e) =>{
        setNewPassword(e.target.value)
    }


    const updatePasswordHandle = (e) =>{
        e.preventDefault()
        const validData = {
            newPassword:newPassword,
            confPassword:confirmPassword
        }
        forgotUpdate.validate(validData,{ abortEarly: false })
        .then(async (res) =>{   
            if(newPassword !== confirmPassword){
                alert("Password is note match")
            }else{
                setIsLoading(true)
                try{  
                    const find_link = query(forgot_password_colRef,where("ResetCode", "==", id));
                    const get_doc = await getDocs(find_link)
                    if(get_doc.size > 0){
                        let link;
                        get_doc.forEach((doc) => {
                            link = doc.data()
                            link.id = doc.id
                        });
                        if(link.Status === 'Pending'){
                            let format_date = new Date(link.ValidTill.seconds * 1000 + link.ValidTill.nanoseconds / 1e6);
                            if(new Date() < format_date){
                                await updateDoc(doc(db,"merchants",link.MerchantId),{
                                    MerchantPassword : Base64.encode(newPassword)
                                })
                                await updateDoc(doc(db,"forgot_passwords",link.id),{
                                    Status : "Used"
                                })
                                setIsLoading(false)
                                isLogin.setIsLogin(false)
                                setNewPassword("")
                                setConfirmPassword("")
                                navigate(`/?msg=Password reset successfully.&flag=success`)
                            }else{
                                await updateDoc(doc(db,"forgot_passwords",link.id),{
                                    Status : "Expired"
                                })
                                setIsLoading(false)
                                isLogin.setIsLogin(false)
                                toast.error('This link is expired.')
                            }
                        }else if(link.Status === 'Used'){
                            setIsLoading(false)
                            isLogin.setIsLogin(false)
                            toast.error('This link is already used.')
                        }else{
                            setIsLoading(false)
                            isLogin.setIsLogin(false)
                            toast.error('This link is expired.')
                        }
                    }else{
                        setIsLoading(false)
                        isLogin.setIsLogin(false)
                        toast.error('This is invalid link.')
                    }
                }catch(err){
                    console.log(err);
                    setIsLoading(false)
                }       
            }   
            setCurrentErrors([])
        }).catch((err) =>{
            setCurrentErrors(err.errors)
        })
    }

    const newShowHide = () =>{
        if(passwordType.newPass === "password"){
            setPasswordType({
                ...passwordType,
                newPass:"text"
            })
        }else{
            setPasswordType({
                ...passwordType,
                newPass:"password"
            })
        }
    }
    const confShowHide = () =>{
        if(passwordType.confPass === "password"){
            setPasswordType({
                ...passwordType,
                confPass:"text"
            })
        }else{
            setPasswordType({
                ...passwordType,
                confPass:"password"
            })
        }
    }

  return (
    <>
        <CustomerNav />
        <div className={style.container}>
            <div className={style.wrapper}>
                <form>
                    <div className={style.formContainer}>
                        <div className={style.resetPass}>
                            <h1>Update password</h1>
                        </div>
                        <div className={style.inputReset}>
                            <div className={style.inputResetField}>
                                <div>
                                    <div>
                                        <input type={passwordType.newPass} value={newPassword} required onChange={newPasswordHandler}/>
                                        <label>New Password</label>
                                    </div>
                                    <div className={style.hidePassword}>
                                            {
                                                passwordType.newPass === "password" ? <i onClick={newShowHide} className="fa-solid fa-eye-slash"></i> 
                                                :
                                                <i onClick={newShowHide}  className="fa-solid fa-eye"></i>
                                            }
                                        </div>
                                    {currentErrors.map((e,index) =>(
                                        <div style={{
                                            fontSize:"0.7rem",
                                            fontWeight:"700",
                                            color:"red",
                                            marginTop:"3px",
                                        }}  key={index}>{e.passNew}</div>
                                    ))
                                    }
                                </div>
                                <div>
                                    <div>
                                        <input type={passwordType.confPass} value={confirmPassword} required onChange={confirmPasswordHandler}/>
                                        <label>Confirm Password</label>
                                    </div>
                                    <div className={style.hidePassword}>
                                            {
                                                passwordType.confPass === "password" ? <i onClick={confShowHide} className="fa-solid fa-eye-slash"></i> 
                                                :
                                                <i onClick={confShowHide}  className="fa-solid fa-eye"></i>
                                            }
                                        </div>
                                    {currentErrors.map((e,index) =>(
                                        <div style={{
                                            fontSize:"0.7rem",
                                            fontWeight:"700",
                                            color:"red",
                                            marginTop:"3px",
                                        }}  key={index}>{e.passConf}</div>
                                    ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={style.resetBtn}>
                            <button className={`${isLoading && style.disableBtn}`} onClick={updatePasswordHandle} type='submit'>Update</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <Footer />
        {
            isLoading && <Loader />
            
        }
    </>
  )
}

export default UpdatePassword